import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
const tickRollover = 0x100000000;
export class TickTimestamp {
    clock;
    ticks;
    constructor(clock) {
        this.clock = clock;
        this.ticks = this.clock.ticks;
    }
    get elapsed() {
        return (tickRollover + this.clock.ticks - this.ticks) % tickRollover;
    }
    get elapsedObs() {
        return this.clock.ticksObs.pipe(map(() => this.elapsed));
    }
}
export class TickTimer extends TickTimestamp {
    timeout;
    constructor(clock, timeout) {
        super(clock);
        this.timeout = timeout;
    }
    get expired() {
        return this.elapsed >= this.timeout;
    }
    get expiredObs() {
        return this.elapsedObs.pipe(map(() => this.expired), distinctUntilChanged());
    }
    get onExpired() {
        return firstValueFrom(this.expiredObs.pipe(filter((v) => v)));
    }
}
export class TickClock {
    tickPeriod;
    ticksSubj = new BehaviorSubject(0);
    timeoutId;
    subscriptions = [];
    constructor(runWhen, tickPeriod) {
        this.tickPeriod = tickPeriod;
        this.subscriptions.push(runWhen.pipe(distinctUntilChanged()).subscribe(this.onRunWhen));
    }
    /** Unsubscribe from `runWhen` */
    teardown() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
    get ticks() {
        return this.ticksSubj.value;
    }
    get ticksObs() {
        return this.ticksSubj.asObservable();
    }
    get now() {
        return new TickTimestamp(this);
    }
    getTimer(timeout) {
        return new TickTimer(this, timeout);
    }
    onRunWhen = (runWhen) => {
        if (runWhen) {
            this.schedule();
        }
        else {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
                this.timeoutId = undefined;
            }
        }
    };
    onTick = () => {
        this.ticksSubj.next((this.ticksSubj.value + 1) % tickRollover);
        this.schedule();
    };
    schedule() {
        this.timeoutId = setTimeout(this.onTick, this.tickPeriod);
    }
}
//# sourceMappingURL=tick-timer.js.map